import {OptionsReasonEnum} from './optionsReasonEnum';

export const SUBJECT_OPTIONS = [
	{
		label: OptionsReasonEnum.PRAISE,
		value: '140',
	},
	{
		label: OptionsReasonEnum.INFORMATION,
		value: '138',
	},
	{
		label: OptionsReasonEnum.SUGGESTION,
		value: '139',
	},
	{
		label: OptionsReasonEnum.COMPLAINTS,
		value: '131',
	},
];
